import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    OutlinedInput,
    Typography,
} from "@mui/material";
import { Card } from "../../../../components/Card";

export const FilterDropdown = ({ label, value, onChange, options }) => (
    <FormControl fullWidth size="small" variant="outlined">
        <InputLabel>{label}</InputLabel>
        <Select
            value={value}
            onChange={onChange}
            input={<OutlinedInput label={label} />}
        >
            {options.map((option) => (
                <MenuItem key={option?.value} value={option?.value}>
                    {option?.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);

export const StatCard = ({ value, label, color, icon }) => (
    <div style={{ textAlign: "center", flex: 1 }}>
        <Typography
            variant="h5"
            sx={{
                color,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
            }}
            mb={0.5}
        >
            {icon}
            {value}
        </Typography>
        <Typography variant="caption" color="text.secondary">
            {label}
        </Typography>
    </div>
);
